export const AppEventSymbol = Symbol('AppEvent');
export const BroadcastEventSymbol = Symbol('BroadcastAppEvent');
